import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Helmet } from "react-helmet";
import Home from './pages/Home';
import ViewMessage from './pages/ViewMessage';
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { useEffect, useState } from 'react';
import useAuth from './data/useAuth';
import Loading from './pages/Loading';
import { getUserInfo } from './data/api';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';


setupIonicReact();


export const ColorContext = React.createContext<any>(null);
const queryClient = new QueryClient();

const App: React.FC = () => {
    const [color, setColor] = useState("#3880ff");
    //const { isLoading, error } = useQuery(['user'], () => getUserInfo(auth, 7888));
    
    return (
        <QueryClientProvider client={queryClient}>
            <ColorContext.Provider value={[color, setColor]}>
                {/*<Helmet>*/}
                {/*    <meta name="theme-color" content={color} />*/}
                {/*    <meta name="apple-mobile-web-app-status-bar-style" content={color} />*/}
                {/*</Helmet>*/}
                <Peer />
                <ReactQueryDevtools />
            </ColorContext.Provider>
        </QueryClientProvider>
    );
}
    
const Peer: React.FC = () => {
    const auth = useAuth();
    //const userQuery = useQuery(['userq'], () => getUserInfo(auth, 0), { retryDelay: 10000, onError: (err:any) => console.log(err) });
    //useEffect(() => {
    //    if (!auth.user) { userQuery.refetch() }
    //})
    return (
        <IonApp>
            <IonReactRouter basename="ReportACrime">
                <IonRouterOutlet>
                    <Route path="/" exact={true}>
                        <Redirect to="/home/1" />
                    </Route>
                    <Route path="/home/:version" exact={true} render={(props: any) => (<Home {...props}/>) } />
                    <Route path="/message/:id">
                        <ViewMessage />
                    </Route>
                </IonRouterOutlet>
            </IonReactRouter>
        </IonApp>
    );
}

export default App;
